'use strict';

// Assigned Dependencies

module.exports = (function() {   
	setupFooterBreadcrumbs();
})();

function setupFooterBreadcrumbs() {
	$('.subscription-form-toggle').click(function() {
		$('.subscription-close').toggle();
		$('.ribbon-wrapper').toggle();
		
		if (!$('.subscription-form').is(':visible')) {
			$('.subscription-form').slideToggle();
			
			LoadDiv(".subscription-form", {
				fuseaction: 'NewsLetterMod.SubscribeNewslettersFormContent', 
				method:'GET',
				ajaxLoader:'/assets/images/ajax-loader-footer.gif', 
				onSuccess:function(){
					moveWindowToElement('.subscription-close',0,800);
					$('.subscription-form').find('input')[0].focus();
				}
			});
		}
		else{
			$('.subscription-form').slideToggle();
			$('.subscription-form').html('');			
		}
		
	});
}